import { Spin, Table } from "antd";
import React, { useEffect, useState } from "react";
import formatMoney from "../../../utils/formatMoney";
import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
import EfficiencyDetails from "./EfficiencyDetails";

export default function TechnicianEfficiency({ startDate, endDate }: any) {
  const [efficiencies, setEfficiencies] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState();
  const [showDetails, setShowDetails] = useState(false);

  const fetchEfficiency = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service/efficiency?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    setEfficiencies(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchEfficiency();
  }, [startDate]);

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record._id === "" ? "Others" : record._id}
        </span>
      ),
    },

    {
      title: "Hrs Allowed",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {(record.hours_allowed / 3).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Hrs Taken",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">{record.hours_taken.toFixed(2)}</span>
      ),
    },
    {
      title: "Efficiency",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {(record.hours_allowed / 3 / record.hours_taken) * 100 > 100
            ? "100"
            : ((record.hours_allowed / 3 / record.hours_taken) * 100).toFixed(
                2
              )}
          %
        </span>
      ),
    },
  ];

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center flex-1 mt-8">
        <Spin />
      </div>
    );
  }

  return (
    <div>
      <Table
        size="small"
        columns={columns}
        pagination={{ pageSize: 7 }}
        scroll={{ y: 550 }}
        rowKey="id"
        dataSource={efficiencies === undefined ? [] : efficiencies}
        onRow={(r) => ({
          onClick: () => {
            setSelected(r);
            setShowDetails(true);
          },
        })}
      />
      <EfficiencyDetails
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        selected={selected}
        services={efficiencies}
      />
    </div>
  );
}
